import { useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULT_BRANDING = {
  business_name: "Maharlika Seafood Mart & Chow",
  restaurant_name: "ChowMaharlika",
  mart_name: "Maharlika Seafood Mart",
  tagline: "Where Filipino Tradition Meets Fresh Quality.",
  header_logo: "",
  footer_logo: "",
  admin_logo: "",
  login_logo: "",
  restaurant_logo: "",
  grocery_logo: "",
  favicon: "",
  social_share_image: "",
  receipt_logo: "",
  daily_menu_logo: "",
  lechon_logo: "",
  rewards_logo: "",
  register_logo: "",
  customer_logo: "",

  landing_restaurant_label: "CHOWMAHARLIKA",
  landing_restaurant_headline_line1: "Where Filipino Tradition",
  landing_restaurant_headline_line2: "Meets Fresh Quality.",
  landing_restaurant_description: "Authentic Filipino flavors. Slow-cooked adobo, sizzling sisig, crispy pata and more — made with love, served with pride.",
  landing_restaurant_primary_cta: "View Menu",
  landing_restaurant_secondary_cta: "Reserve Lechon",
  landing_grocery_label: "MAHARLIKA MART",
  landing_grocery_headline: "Your Filipino grocery destination",
  landing_grocery_description: "Fresh seafood, daily catches, Filipino pantry staples — quality products at honest prices. Tuloy po kayo!",
  landing_grocery_primary_cta: "Shop Now",
  landing_grocery_secondary_cta: "View Deals",
};

export default function useBranding() {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/branding")
      .then(({ data }) => setBranding({ ...DEFAULT_BRANDING, ...data }))
      .catch(() => setBranding(DEFAULT_BRANDING))
      .finally(() => setLoading(false));
  }, []);

  return { branding, loading };
}
